import { Loader, SnackBar } from 'ui/services';
import CONFIG from 'ui/config';
import { injectJS } from 'ui/lib/loadJs';
import { initPaytmCheckout } from 'components/utils/payments';

export const handlePaytm = async (shop, data) => {
  Loader.show();
  const src = `${CONFIG.PAYTM.host}/merchantpgpui/checkoutjs/merchants/${data.txnKey}.js`;
  await injectJS('paytmPg', src, { crossorigin: 'anonymous' });
  const config = {
    root: '',
    flow: 'DEFAULT',
    data: {
      'tokenType': 'TXN_TOKEN',
      'token': data.txnToken,
      'orderId': data.pgTid,
    },
    handler: {
      notifyMerchant: (eventName, data) => {
        console.log(eventName, data);
      }
    },
  };
  try {
    await initPaytmCheckout();
    await window.Paytm.CheckoutJS.init(config);
    await window.Paytm.CheckoutJS.invoke();
    Loader.hide();
  } catch (e) {
    Loader.hide();
    SnackBar.showError(e);
  }
};
